import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";

const BASE_URL = "https://partyhousedatabase-rpft.onrender.com";

export default function AdminRegister() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await fetch(`${BASE_URL}/admin/register`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });
    const data = await res.json();

    if (res.ok) {
      alert("Admin Registered Successfully");
      navigate("/admin/login");
    } else {
      alert(data.error);
    }
  };

  return (
    <div style={container}>
      <h2>Admin Register</h2>
      <form onSubmit={handleSubmit} style={formStyle}>
        <input
          placeholder="Full Name"
          value={form.name}
          onChange={(e) => handleChange("name", e.target.value)}
          style={input}
          required
        />
        <input
          placeholder="Email"
          type="email"
          value={form.email}
          onChange={(e) => handleChange("email", e.target.value)}
          style={input}
          required
        />
        <input
          placeholder="Phone Number"
          type="tel"
          value={form.phone}
          onChange={(e) => handleChange("phone", e.target.value)}
          style={input}
          required
        />

        {/* Password Field */}
        <div style={passwordWrapper}>
          <input
            placeholder="Password"
            type={showPassword ? "text" : "password"}
            value={form.password}
            onChange={(e) => handleChange("password", e.target.value)}
            style={inputWithIcon}
            required
          />
          <span
            style={eyeIcon}
            onClick={() => setShowPassword((prev) => !prev)}
          >
            {showPassword ? <FiEyeOff /> : <FiEye />}
          </span>
        </div>

        {/* Confirm Password Field */}
        <div style={passwordWrapper}>
          <input
            placeholder="Confirm Password"
            type={showConfirmPassword ? "text" : "password"}
            value={form.confirmPassword}
            onChange={(e) => handleChange("confirmPassword", e.target.value)}
            style={inputWithIcon}
            required
          />
          <span
            style={eyeIcon}
            onClick={() => setShowConfirmPassword((prev) => !prev)}
          >
            {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
          </span>
        </div>

        <button type="submit" style={button}>
          Register
        </button>
      </form>
    </div>
  );
}

// Styles
const container = {
  width: "100%",
  maxWidth: "400px",
  margin: "70px auto",
  padding: "30px",
  boxShadow: "0 0 10px rgba(0,0,0,0.1)",
  borderRadius: "10px",
};

const formStyle = { display: "flex", flexDirection: "column", gap: "15px" };
const input = { padding: "12px", borderRadius: "8px", border: "1px solid #ccc" };
const button = {
  padding: "12px",
  background: "#c59d5f",
  border: "none",
  borderRadius: "8px",
  color: "#fff",
  cursor: "pointer",
};

// Input wrapper to keep icon inside input
const passwordWrapper = {
  position: "relative",
  display: "flex",
  alignItems: "center",
};

// Input style with space for icon
const inputWithIcon = {
  padding: "12px",
  borderRadius: "8px",
  border: "1px solid #ccc",
  width: "100%",
  paddingRight: "40px", // space for eye icon
};

// Eye icon inside input
const eyeIcon = {
  position: "absolute",
  right: "10px",
  cursor: "pointer",
  fontSize: "18px",
  color: "#555",
};
